export default "__VITE_ASSET__9UDEeVcL__"